import * as $ from 'jquery';
import { eID } from '../../services/dom';

export function activateInfoButton(btnId: string, contentId: string): void {
    let visible = false;

    const btn = eID(btnId);
    const { classList } = eID(contentId);

    document.addEventListener('click', event => {
        const shouldShow = !!$(event.target!).closest(btn).length && !visible;

        if (shouldShow) classList.add('showing');
        else classList.remove('showing');

        visible = shouldShow;
    });
}

export default function activateFlightInfoButton(): void {
    activateInfoButton('flight-info-btn', 'flight-info-content');
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/flight-info-btn.ts